

import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
XHeader,
Group,
XInput
},
data () {
return {
name:"",
}
},
methods: {

}
}



// WEBPACK FOOTER //
// ./src/views/user/editName.vue